// extracted by mini-css-extract-plugin
export default {"Errorpage":"thankyou_Errorpage__U5cvM","imgText":"thankyou_imgText__No-qB","images":"thankyou_images__X7Jqr","TextHead":"thankyou_TextHead__hq6QQ","button":"thankyou_button__zjTQA"};